import { MeshGradient } from "@paper-design/shaders-react"
import { useEffect, useState } from "react"

export function AmbientBackground() {
  const [paused, setPaused] = useState(false)

  useEffect(() => {
    const onVisibility = () => setPaused(document.hidden)
    document.addEventListener("visibilitychange", onVisibility)
    return () => document.removeEventListener("visibilitychange", onVisibility)
  }, [])

  return (
    <div className="ambient" aria-hidden="true">
      <MeshGradient
        className="ambient__shader"
        colors={["#050708", "#101518", "#242a2d", "#070a0b"]}
        speed={paused ? 0 : 0.18}
      />
      <div className="ambient__veil" />
      <div className="ambient__grain" />
    </div>
  )
}
